export default "__VITE_ASSET__Cre58$_Y__"